<template lang="pug">
  div
    .text-right.mb-2
      b-button(variant="primary", size="sm", :disabled="creating", @click="createFilter" ) Agregar filtro
    .text-center(v-if="loading")
      b-spinner(variant="primary")
    PropertyFilter.mb-2(v-for="(filter, index) in filters", :key="index", :filter="filter")
    .d-flex.align-items-center(v-if="v_paginationShow")
      b-pagination.mb-0.mr-3( size="sm", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getFilters')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount")
      b-spinner(small, variant="primary", v-if="loading")
</template>

<script>
import PropertyFilter from '@/components/PropertyFilter.vue'
import {createNamespacedHelpers, mapActions} from 'vuex'
const propertyFilterController = createNamespacedHelpers('property_filter')

export default {
  name: 'QuestionBlockFilters',
  data () {
    return {
      loading: false,
      creating: false,
    }
  },
  computed: {
    ...propertyFilterController.mapState({
      filters: state => state.filters
    })
  },
  methods: {
    ...mapActions([
        'property_filter/all',
        'property_filter/create',
        'property_filter/update',
        'property_filter/destroy',
    ]),
    getFilters () {
      this.loading = true

      this['property_filter/all']({
        account_id: this.$route.params.account_id,
        params: {
          ...this.paginationParamsObject,
        },
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          this.parsePaginationDataFromResponse(res)
        }
      })
    },
    createFilter() {
      this.creating = true

      this['property_filter/create']({
        account_id: this.$route.params.account_id,
        title: 'nuevo filtro',
        properties: [],
        callback: res => {
          this.creating = false
          if (res.error) return this.$message.error(res.error)
        }
      })
    }
  },
  mounted () {
    this.getFilters()
  },
  components: {PropertyFilter}
}
</script>

<style lang="scss" scoped>

</style>
